<template>
	<div class="alert_overlay" v-if="isVisible">
		<div class="alert_wrapper">
			<div class="title heading_7">{{ title }}</div>
			<div class="content_wrapper body_8 f_gray_4">{{ content }}</div>
			<div class="alert_button_wrapper" v-if="!!primaryText || !!secondaryText">
				<button v-if="!!primaryText" class="button_container button_44 button_3 button_primary button_full" @click="handlePrimaryClick">
					{{ primaryText }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		size: {
			type: Number,
			default: 56
		},
		disabled: {
			type: Boolean,
			default: false
		},
		isVisible: {
			type: Boolean,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		content: {
			type: String,
			required: false
		},
		primaryText: {
			type: String,
			default: ''
		},
		secondaryText: {
			type: String,
			default: ''
		},
		onClickPrimary: {
			type: Function
		},
		onClickSecondary: {
			type: Function
		}
	},
	components: {
	},
	methods: {
		handlePrimaryClick() {
			this.onClickPrimary()
		},
		handleSecondaryClick() {
			this.onClickSecondary()
		},
	}
}
</script>

<style scope>
.alert_overlay {
	position: fixed;
	overflow: auto;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: var(--zIndex-dim);
	transition: opacity 0.3s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.alert_wrapper {
	width: 100%;
	background-color: var(--gray-scale-12);
	padding: 24px 12px;
	border-radius: 16px;
	z-index: var(--zIndex-alert);
}

.alert_wrapper>.title {
	text-align: center;
	white-space: pre-line;
	margin-bottom: 24px;
}

.alert_wrapper>.content_wrapper {
	white-space: pre-line;
	word-break: keep-all !important;
	text-align: center;
}

.alert_button_wrapper {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 24px;
}

.button_container {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	transition: background 0.3s;
}

.button_full {
	width: 100%;
}

.button_56 {
	padding: 16px 12px;
	height: 56px;
}

.button_44 {
	padding: 16px 10px;
	height: 44px;
}

.button_36 {
	padding: 8px 12px;
	height: 36px;
}

.button_primary {
	background-color: var(--primary-color-1);
	color: var(--gray-scale-12);
}
</style>






// WEBPACK FOOTER //
// src/modules/template/AiAlertTemplate.vue